import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { IAuthenticationService } from 'app/+common/contracts/authentication.service.contract';
import { Account } from 'app/+auth/common/model/account.model';

declare var $: any;

@Component({
    selector: 'sa-header',
    templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit
{
    account: Account;

    constructor(private router: Router, @Inject('IAuthenticationService') private authService: IAuthenticationService) { }

    ngOnInit() 
    { 
        this.account = this.authService.getUserAccount();
    }

    searchMobileActive = false;

    toggleSearchMobile()
    {
        this.searchMobileActive = !this.searchMobileActive;

        $('body').toggleClass('search-mobile', this.searchMobileActive);
    }

    onSubmit()
    {
        this.router.navigate(['/miscellaneous/search']);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/header.component.ts